import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {  faCalendarWeek } from '@fortawesome/free-solid-svg-icons';

interface Idata {
  label : string,
  value : number
}
@Component({
  selector: 'app-custom-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrl: './custom-date-picker.component.scss'
})
export class CustomDatePickerComponent implements OnInit, OnChanges {
  faCalendar = faCalendarWeek

  @Input() numberOfDays :any = 365;
  @Input() minDate :any =  new Date();
  @Output() selectedDates: EventEmitter<any> = new EventEmitter();

  selectedDateRange : number = 0;
  startDate: any;
  endDate : any;
  disabledDates: any;
  displayStartDate: string = '';
  displayEndDate: string = '';

  constructor(private readonly datePipe: DatePipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['numberOfDays'] && changes['numberOfDays'].currentValue) {
      this.numberOfDays = changes['numberOfDays'].currentValue;
      this.prepareStartAndEndDate(this.numberOfDays);
    }
  }

  ngOnInit(): void {
    const today = new Date();
    let start = new Date(today);
    if (this.numberOfDays > 0) {
      start.setDate(start.getDate() - this.numberOfDays);
    }
    this.startDate = this.datePipe.transform(start, 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    this.displayStartDate = this.datePipe.transform(start, 'dd-MMM-yyyy')!;
    this.displayEndDate = this.datePipe.transform(today, 'dd-MMM-yyyy')!;
    this.disabledDates = this.datePipe.transform(today, 'yyyy-MM-dd');
  }

  handleSelectedDateRange(dateRange: number) {
    if (this.selectedDateRange === dateRange) {
      return;
    }
    this.selectedDateRange = dateRange;
    this.prepareStartAndEndDate(dateRange);
  }

  handleSelectedCustomDate(){
    this.selectedDateRange = -1;
    this.updateDisplayDates();
    this.emitValues();
  }

  prepareStartAndEndDate(days: number) {
    const today = new Date();
    let start = new Date(today);
    if (days > 0) {
      start.setDate(start.getDate() - days);
    }

    this.startDate = this.datePipe.transform(start, 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(today, 'yyyy-MM-dd');

    this.displayStartDate = this.datePipe.transform(start, 'dd-MMM-yyyy')!;
    this.displayEndDate = this.datePipe.transform(today, 'dd-MMM-yyyy')!;

    this.emitValues();
  }

  updateDisplayDates() {
    if (this.startDate) {
      this.displayStartDate = this.datePipe.transform(this.startDate, 'dd-MMM-yyyy')!;
    }
    if (this.endDate) {
      this.displayEndDate = this.datePipe.transform(this.endDate, 'dd-MMM-yyyy')!;
    }
  }

  emitValues() {
    this.selectedDates.emit({
      created_datefrom: this.startDate,
      created_dateupto: this.endDate
    });
  }

  openDatePicker(event: any) {
    setTimeout(() => {
      event.target.showPicker?.();
    });
  }
}
